import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './testimonial17.css'

const Testimonial17 = (props) => {
  return (
    <div className="thq-section-padding">
      <div className="testimonial17-max-width thq-section-max-width">
        <div className="testimonial17-container10">
          <h2 className="thq-heading-2">
            {props.heading1 ?? (
              <Fragment>
                <span className="testimonial17-text33">Testimonials</span>
              </Fragment>
            )}
          </h2>
          <span className="testimonial17-text11 thq-body-small">
            {props.content1 ?? (
              <Fragment>
                <span className="testimonial17-text31">
                  Read what our users have to say about their experience with
                  our crypto coin.
                </span>
              </Fragment>
            )}
          </span>
        </div>
        <div className="thq-grid-2">
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card1"
              >
                <div className="testimonial17-container12">
                  <img
                    alt={props.author1Alt}
                    src={props.author1Src}
                    className="testimonial17-image1"
                  />
                  <div className="testimonial17-container13">
                    <strong className="thq-body-large">
                      {props.author1Name ?? (
                        <Fragment>
                          <span className="testimonial17-text37">John Doe</span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author1Position ?? (
                        <Fragment>
                          <span className="testimonial17-text24">
                            Crypto Investor
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text14 thq-body-small">
                  {props.review1 ?? (
                    <Fragment>
                      <span className="testimonial17-text28">
                        I have been using this crypto coin for a while now, and
                        I must say it has exceeded my expectations. The team
                        behind it is dedicated and the community support is
                        fantastic.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card2"
              >
                <div className="testimonial17-container14">
                  <img
                    alt={props.author2Alt}
                    src={props.author2Src}
                    className="testimonial17-image2"
                  />
                  <div className="testimonial17-container15">
                    <strong className="thq-body-large">
                      {props.author2Name ?? (
                        <Fragment>
                          <span className="testimonial17-text26">
                            Jane Smith
                          </span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author2Position ?? (
                        <Fragment>
                          <span className="testimonial17-text30">
                            Blockchain Enthusiast
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text17 thq-body-small">
                  {props.review2 ?? (
                    <Fragment>
                      <span className="testimonial17-text35">
                        As someone who is passionate about blockchain
                        technology, I find this crypto coin to be a
                        game-changer. The innovative features and strong
                        security measures make it stand out from the rest.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card3"
              >
                <div className="testimonial17-container16">
                  <img
                    alt={props.author3Alt}
                    src={props.author3Src}
                    className="testimonial17-image3"
                  />
                  <div className="testimonial17-container17">
                    <strong className="thq-body-large">
                      {props.author3Name ?? (
                        <Fragment>
                          <span className="testimonial17-text29">
                            David Lee
                          </span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author3Position ?? (
                        <Fragment>
                          <span className="testimonial17-text34">
                            Tech Entrepreneur
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text20 thq-body-small">
                  {props.review3 ?? (
                    <Fragment>
                      <span className="testimonial17-text36">
                        I started investing in this crypto coin early on, and I
                        have seen remarkable growth in its value. The
                        transparency and reliability of the platform make it a
                        top choice for me.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card4"
              >
                <div className="testimonial17-container18">
                  <img
                    alt={props.author4Alt}
                    src={props.author4Src}
                    className="testimonial17-image4"
                  />
                  <div className="testimonial17-container19">
                    <strong className="thq-body-large">
                      {props.author4Name ?? (
                        <Fragment>
                          <span className="testimonial17-text27">
                            Sarah Johnson
                          </span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author4Position ?? (
                        <Fragment>
                          <span className="testimonial17-text25">
                            Crypto Trader
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text23 thq-body-small">
                  {props.review4 ?? (
                    <Fragment>
                      <span className="testimonial17-text32">
                        Trading with this crypto coin has been a seamless
                        experience for me. The user-friendly interface and quick
                        transaction speeds have made it my go-to choice in the
                        market.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Testimonial17.defaultProps = {
  author1Position: undefined,
  author4Position: undefined,
  author1Src:
    'https://images.unsplash.com/photo-1607804963476-d3f632024736?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0ODk3ODM0NXw&ixlib=rb-4.1.0&q=80&w=1080',
  author3Alt: 'David Lee Image',
  author2Name: undefined,
  author3Src:
    'https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0ODk3ODM0NXw&ixlib=rb-4.1.0&q=80&w=1080',
  author4Name: undefined,
  author4Src:
    'https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0ODk3ODM0NXw&ixlib=rb-4.1.0&q=80&w=1080',
  review1: undefined,
  author3Name: undefined,
  author2Position: undefined,
  content1: undefined,
  author1Alt: 'John Doe Image',
  review4: undefined,
  heading1: undefined,
  author3Position: undefined,
  author2Src:
    'https://images.unsplash.com/photo-1523779917675-b6ed3a42a561?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0ODk3ODM0NXw&ixlib=rb-4.1.0&q=80&w=1080',
  author4Alt: 'Sarah Johnson Image',
  review2: undefined,
  author2Alt: 'Jane Smith Image',
  review3: undefined,
  author1Name: undefined,
}

Testimonial17.propTypes = {
  author1Position: PropTypes.element,
  author4Position: PropTypes.element,
  author1Src: PropTypes.string,
  author3Alt: PropTypes.string,
  author2Name: PropTypes.element,
  author3Src: PropTypes.string,
  author4Name: PropTypes.element,
  author4Src: PropTypes.string,
  review1: PropTypes.element,
  author3Name: PropTypes.element,
  author2Position: PropTypes.element,
  content1: PropTypes.element,
  author1Alt: PropTypes.string,
  review4: PropTypes.element,
  heading1: PropTypes.element,
  author3Position: PropTypes.element,
  author2Src: PropTypes.string,
  author4Alt: PropTypes.string,
  review2: PropTypes.element,
  author2Alt: PropTypes.string,
  review3: PropTypes.element,
  author1Name: PropTypes.element,
}

export default Testimonial17
